import { getExchangeUrl } from '@/utils/location';

const createTradeApi = (url: string) => `${url}`;

const createUserApi = (url: string) => `/u${url}`;

const createMarketApi = (url: string) => `/market${url}`;

const createUserCenterApi = (url: string) => `/uaapi${url}`;

export const API = {
  //
  // 委托订单接口
  //

  // 计划委托与止盈止损
  ENTRUST_PLAN_CANCEL: createTradeApi('/lm/entrust/cancelPlanEntrust'), // 撤销计划委托
  ENTRUST_PLAN_CANCEL_ALL: createTradeApi('/lm/entrust/cancelAllPlanEntrust'), // 撤销所有计划委托
  ENTRUST_PROFIT_CANCEL: createTradeApi('/lm/entrust/cancelProfitEntrust'), // 撤销止盈止损
  ENTRUST_PLAN_CREATE: createTradeApi('/lm/entrust/createPlanEntrust'), // 创建计划委托
  ENTRUST_PROFIT_CREATE: createTradeApi('/lm/entrust/createProfitEntrust'), // 创建止盈止损
  ENTRUST_PLAN_DETAIL: createTradeApi('/lm/entrust/getEntrustByEntrustId'), // 根据entrustId查询计划委托
  ENTRUST_PLAN_LIST: createTradeApi('/lm/entrust/getPlanEntrusts'), // 计划委托列表
  ENTRUST_PROFIT_DETAIL: createTradeApi('/lm/entrust/getEntrustByProfitId'), // 止盈止损详情
  ENTRUST_PROFIT_LIST: createTradeApi('/lm/entrust/getProfitEntrusts'), // 止盈止损列表
  ENTRUST_PROFIT_UPDATE: createTradeApi('/lm/entrust/updateProfitEntrust'), // 修改止盈止损
  ENTRUST_PROFIT_ALL_CANCEL: createTradeApi('/lm/entrust/cancelAllProfitEntrust'), // 撤销所有止盈止损

  // 移动止盈止损
  TRAILING_STOP_CREATE: createTradeApi('/lm/entrust/createMoveProfit'), // 创建移动止盈止损
  TRAILING_STOP_CANCEL: createTradeApi('/lm/entrust/cancelKMoveProfit'), // 撤销移动止盈止损
  TRAILING_STOP_CANCEL_ALL: createTradeApi('/lm/entrust/cancelAllMoveProfit'), // 撤销所有移动止盈止损
  TRAILING_STOP_LIST: createTradeApi('/lm/entrust/getMoveProfitList'), // 移动止盈止损列表
  TRAILING_STOP_UPDATE: createTradeApi('/lm/entrust/updateProfitEntrust'), // 修改移动止盈止损

  // 限价委托与市价委托
  ORDER_CANCEL: createTradeApi('/lm/commission/cancelOrder'), // 撤销
  ORDER_CANCEL_ALL: createTradeApi('/lm/commission/cancelAllBySymbol'), // 撤销所有订单 当前委托
  ORDER_CREATE: createTradeApi('/lm/commission/createOrder'), // 下单
  ORDER_CREATE_BATCH: createTradeApi('/v1/order/create-batch'), // 批量下单
  ORDER_DETAIL: createTradeApi('/lm/commission/getOrderByOrderId'), // 根据id查询订单
  ORDER_LIST: createTradeApi('/lm/commission/getOrdersList'), // 订单列表
  ORDER_HISTORY: createTradeApi('/lm/commission/getHistoryList'), // 历史订单列表
  ORDER_BILL_LIST: createTradeApi('/lm/commission/getTradeList'), // 订单成交明细

  LEADER_ORDER_LIST: createTradeApi('/lm/copyTrade/getLeaderOrders'), // 查询当前带单(主页面跟单)
  USER_CREATE_COPY_TRADE: createTradeApi('/lm/copyTrade/userCreateCopyTrade'), // 查询带单员信息
  FOLLOWER_ORDER_LIST: createTradeApi('/lm/copyTrade/getFollowerOrders'), // 查询当前跟单(主页面)
  LEADER_ORDER_CLOSE: createTradeApi('/lm/copyTrade/closePosition'), // 带单-跟单平仓
  LEADER_ORDER_CLOSE_ALL: createTradeApi('/lm/copyTrade/closeAllPosition'), // 带单-跟单一键平仓
  FOLLOWER_ORDER_CLOSE: createTradeApi('/lm/copyTrade/closePosition'), // 带单-跟单平仓
  FOLLOWER_ORDER_CLOSE_ALL: createTradeApi('/lm/copyTrade/closeAllPosition'), // 带单-跟单一键平仓
  FOLLOWER_ORDER_STOP: createTradeApi('/lm/copyTrade/updateProfitEntrust'), // 带单-跟单 止盈止损

  // 
  // 用户其他接口
  // 
  LEADERSYMBOL: createUserApi("/copyTrade/getLeaderSymbol"),

  // listenKey
  LISTEN_KEY: createUserApi('/inspectsrec'), // 获取listen-key，用于ws订阅
  // 持仓相关
  POSITION_UPDATE_LV: createUserApi('/position/adjustLeverage'), // 调整杠杆倍数
  POSITION_UPDATE_TYPE: createUserApi('/position/updatePositionType'), // 调整杠杆倍数
  POSITION_ADL_LIST: createUserApi('/position/getAdl'), // ADL
  POSITION_AUTO_MARGIN: createUserApi('/position/adjustPositionAutoMargin'), // 自动追加保证金
  POSITION_LIST: createUserApi('/position/getPositionList'), // 持仓信息
  POSITION_UPDATE_MARGIN: createUserApi('/position/adjustPositionMargin'), // 修改保证金
  POSITION_ADD: (positionId: string) => createUserApi(`/position/${positionId}/scale`), // 加仓
  POSITION_UPDATE_MODE: createUserApi('/position/updatePositionType'), // 修改持仓模式
  POSITION_MODE_CONF: createUserApi('/position/getPositionConfsInfo'), // 获取持仓配置信息
  POSITION_INIT_LEVERAGE: createUserApi('/position/getPositionInitLeverage'), // 默认杠杆
  POSITION_COLSE_ALL: createUserApi('/position/closeAllPosition'), // 一键平仓 fetchPositionList
  // 接管记录
  TAKEOVER_LIST: createUserApi('/v1/taker-over/list'), // 查询接管记录
  // 收藏交易对
  COLLECTION_ADD: createUserApi('/collection/addCollection'),
  COLLECTION_CANCEL: createUserApi('/collection/cancelCollection'),
  COLLECTION_LIST: createUserApi('/collection/getCollectionList'),
  // 用户合约相关信息
  ACCOUNT_INFO: createUserApi('/account/getinfo'), // 账户相关信息
  ACCOUNT_OPEN: createUserApi('/account/openFutures'), // 开通合约
  // 用户资金相关
  BALANCE_BILLS: createUserApi('/account/getBills'), // 资金流水
  BALANCE_DETAIL: createUserApi('/account/detail'), // 获取单币种资金
  BALANCE_FUNDING_RATE: createUserApi('/account/getFundingList'), // 资金费用
  BALANCE_LIST: createUserApi('/account/list'), // 获取用户资产
  BALANCE_TRANSFER: createUserApi('/v1/balance/transfer'), // 资产划转
  // 杠杆分层
  LEVERAGE_BRACKET_DETAIL: createUserApi('/leverage/getBracketDetail'), // 查询单个交易对杠杆分层
  LEVERAGE_BRACKET_LIST: createUserApi('/leverage/getBracketList'), // 查询所有交易对杠杆分层
  // 阶梯费率
  STEP_RATE_TABLE: createUserApi('/user/stepRate/getStepRates'), // 查询阶梯费率表
  USER_STEP_RATE: createUserApi('/user/stepRate/getUserStepRate'), // 查询用户阶梯费率
  OTHER_PLATFORM: createUserApi('/user/stepRate/getOtherPlatforms'), // 查询第三方平台
  USER_APPLY_RESULT: createUserApi('/user/stepRate/getUserStepApplyResult'), // 查询用户申请结果
  UPLOAD_IMG: createUserApi('/v1/user/step-rate/upload'), // 上传图片
  RECENT_TRADE: createUserApi('/user/stepRate/findRecentTrade'), // 查询近期交易
  APPLY_PRO_RATE: createUserApi('/user/stepRate/'), // 申请阶梯费率
  APPLY_COPY_STATE: createUserApi('/copyTrade/getLeaderApplyStateV2'), // 交易员申请状态
  billsConf: createUserApi('/account/fund'), // 交易员申请状态

  //
  // 行情等接口
  //

  // 合约信息
  RISK_FUND_LIST: createMarketApi('/v1/public/contract/risk-balance'), // 获取交易对风险基金余额
  // 获取交易对配置信息
  SYMBOL_COIN_LIST: createMarketApi('/config/tradePairs/getCoinList'), // 获取交易对币种
  SYMBOL_CONFIG_DETAIL: createMarketApi('/v1/public/symbol/detail'), // 单个交易对配置信息
  SYMBOL_CONFIG_LIST: createMarketApi('/config/tradePairs/getList'), // 所有交易对配置信息
  // 行情类接口
  TICKER_TRADE_LATEST_LIST: createMarketApi('/config/mc/getDeals'), // 获取交易对的最新成交信息
  TICKER_DEPTH_LIST: createMarketApi('/config/mc/getDepth'), // 获取交易对的深度信息
  TICKER_FUNDING_RATE: createMarketApi('/config/mc/getFundingRate'), // 获取资金费率
  TICKER_FUNDING_RATE_RECORD: createMarketApi('/config/mc/getFundingRateRecord'), // 获取资金费率记录
  TICKER_INDEX_PRICE: createMarketApi('/config/mc/getAllIndexPrice'), // 获取所有交易对的指数价格
  TICKER_KLINE: createMarketApi('/config/mc/getKline'), // 获取交易对的k线信息
  TICKER_MARK_PRICE: createMarketApi('/config/mc/getAllMarkPrice'), // 获取所有交易对的标记价格
  TICKER_CURRENT_SYMBOL: createMarketApi('/config/mc/getTicker'), // 获取指定交易对的行情信息
  TICKER_LIST: createMarketApi('/config/mc/getTickers'), // 获取全交易对的行情信息

  // summer活动相关接口
  ACTIVITY_DRAW: createUserApi('/v1/activity/draw'), // 抽奖
  ACTIVITY_LOTTERY_WHEEL: createUserApi('/v1/public/activity/lottery-wheel'), // 抽奖转盘信息
  ACTIVITY_LOTTERY_USER_RECORD: createUserApi('/v1/activity/lottery-wheel/user-win-record'), // 用户转盘中奖记录
  ACTIVITY_DETAIL: createUserApi('/v1/public/activity/detail'), // 根据id获取活动详情
  ACTIVITY_LIST: createUserApi('/v1/public/activity/list'), // 获取活动列表
  ACTIVITY_LOTTERY_PLATFORM_RECORD: createUserApi('/v1/public/activity/lottery-wheel/all-win-record'), // 查询转盘平台中奖记录
  ACTIVITY_TASK_LIST: createUserApi('/v1/public/activity/tasks'), // 获取活动任务信息
  ACTIVITY_RECEIVE: createUserApi('/v1/activity/receive-reward'), // 领取奖励（提现）
  ACTIVITY_RECEIVE_LOTTERY: createUserApi('/v1/activity/receive-prize'), // 领取奖励（抽奖）
  ACTIVITY_REWARDS: createUserApi('/v1/activity/rewards'), // 查询奖励列表
  ACTIVITY_SHARE_LINK: createUserApi('/v1/public/activity/share-link-visit'), // 活动邀请访问统计
  ACTIVITY_LOTTERY_WHEEL_TASK_PROGRESS: createUserApi('/v1/activity/lottery-wheel/task-progress'), // 查询用户转盘任务完成进度
  ACTIVITY_INITIAL_REWARD_INFO: createUserApi('/v1/activity/initial-reward-info'), // 获取初始奖励领取信息
  ACTIVITY_RECEIVE_INITIAL_REWARD: createUserApi('/v1/activity/receive-initial-reward'), // 领取初始奖励领
  COPY_TRADE_USER: createUserApi('/copyTrade/info'), // 交易员带单员信息
  MY_PROFIT_STATS: createUserApi('/copyTrade/getDivideProfitStats'), // 交易员首页-带单分润

  // 注册相关接口
  SIGNUP_COUNTRY_IP_CHECK: createUserCenterApi('/user/user/country/checkCountryIpIsIntercept'), // 判断当前ip所属国家是否拦截注册
  SIGNUP_COUNTRY_LIST: createUserCenterApi('/user/user/country/countryInfos'), // 根据操作类型以及设备类型以及语言获取国家信息
  SIGNUP_SENDING_MSG: createUserCenterApi('/user/msg/doSendCode'), // 发送短信邮箱验证码
  SIGNUP_PASSWD_PUBLICKEY: createUserCenterApi('/uaa/authorize/passwd/publicKey'), // 获取密码公钥
  SIGNUP_REG: createUserCenterApi('/user/reg'), // 注册用户
  SIGNUP_SET_SAFE_PWD: createUserCenterApi('/uaa/authorize/token/setSafePwd'), // 设置安全码，成功后，获取token

  // OTC相关接口
  OTC_SELL_LIST: '/foreign/advert/getMyList', // 广告卖出列表
  OTC_ADD_ADV: '/foreign/advert/createAdvertising', // 新增广告
  OTC_PUBLISH_ADV: '/foreign/advert/publishAdvertising', // 发布/上架广告
  OTC_NOD_ADV: '/foreign/advert/updateAdvertising', // 修改广告
  OTC_DEL_ADV: '/foreign/advert/delete', // 删除广告
  OTC_ADV_INFO: '/foreign/advert/advertisingInfo', // 广告详情
  OTC_SOLD_ADV: '/foreign/advert/soldOut', // 下架广告
  OTC_SET_RECE: '/foreign/user/setReceipt', // 收付款
  OTC_UPLOAD: '/foreign/commons/upload', // 上传图片
  OTC_CANCEL: '/foreign/order/cancelOrder', // 撤单
  OTC_COMFIRM_PAYMENT: '/foreign/order/confirmPayment', // 确认付款
  OTC_ORDER_LIST: '/foreign/order/getList', // 我的订单
  OTC_ORDER_INFO: '/foreign/order/getOrderInfo/v2', // 订单详情
  OTC_COMFIRM_RECEIPT: '/foreign/order/confirmReceipt', // 确认收款并放币
  OTC_AD_SUPP: '/foreign/advert/supportCurrency', // 币种信息
  OTC_AD_QUICKORDER: '/foreign/advert/quickOrderConfig', // 快速下单配置
  OTC_AD_QUICKADVER: '/foreign/advert/quickAdvertising', // 快速下单广告查询
  OTC_AD_LIST: '/foreign/advert/getList', // 首页广告
  OTC_AD_LIST_INFO: '/foreign/advert/advertisingInfo', // 广告详情
  OTC_ORDER_CREATV2: '/foreign/order/createOrderV2', // 下单V2
  OTC_ORDER_REPLY_PULL: '/foreign/order/orderReplyPull', // c2c订单-拉取消息
  OTC_ORDER_REPLY_REALTIME: '/otc/order/reply/realtime', // c2c订单-实时推送消息
  OTC_ORDER_REPLY_LIST: '/foreign/order/reply/orderReplyList', // c2c订单-回复列表
  OTC_ORDER_REPLY_CREATETXT: '/foreign/order/reply/userCreateReplyTxt', // 创建c2c订单-回复文字
  OTC_ORDER_REPLY_CREATEIMG: '/foreign/order/reply/userCreateReplyImage', // 创建c2c订单-回复 图片
  OTC_USER_UPDATERP: '/foreign/user/updateReceiptStatus', // 修改收付款方式状态
  OTC_USER_GETRP: '/foreign/user/getOtcReceipt', // 获取所有收付款信息
  OTC_ORDER_INFO_GET: '/foreign/order/getOrderInfo', // 订单详情
  OTC_USER_DELRECRIPT: '/foreign/user/deleteReceipt', // 删除收付款方式
  OTC_ORDER_CONFIRMPAYMENT: '/foreign/order/confirmPayment', // 确认付款
  OTC_ORDER_CONFIRMRECEIPT: '/foreign/order/confirmReceipt', // 确认付款
  OTC_ORDER_CANCEL: '/foreign/order/cancelOrder', // 确认付款
  OTC_ORDER_GETRECEIPT: '/foreign/order/getMerchantReceipt', // 根据订单Id获取卖方收款方式
  OTC_ORDER_UNFINISHEDCOUNT: '/foreign/order/getUnfinishedOrderCount', // 未完成订单数

  OTC_INFO: '/foreign/user/getinfo', // 用户信息
  OTC_ADDPAYEE: '/foreign/business/addOtcPayee', // 添加收款人
  OTC_APPLY: '/foreign/business/applyOtcMerchant', // 申请商家
  OTC_CHECK_NAME: '/foreign/business/checkNickName', // 昵称校验
  OTC_GET_MARCHANT: '/foreign/business/businessinfo', // 获取商家信息
  OTC_GET_PAYEE_LIST: '/foreign/business/getPayeeList', // 获取收款人列表
  OTC_GET_MARCHANT_PAGE: '/foreign/business/merchantPage', // 商家信息
  OTC_QUIT_MARCHANT: '/foreign/business/quitMerchant', // 退出商家
  OTC_QUITVERIFY_MARCHANT: '/foreign/business/merchantQuitVerify', // 能否退出商家
  OTC_UNBIND_MARCHAN: '/foreign/business/unbindOtcPayee', // 解绑收款人
  OTC_UPGRADE_MARCHAN: '/foreign/business/upgradeMerchant', // 升级商家
  OTC_MARCHANT_AD_INFO: '/foreign/advert/getMerchantInfo', // 商家的广告详情
  OTC_HISTOTY_LIST: '/foreign/balance/getBalanceHistory', // 资金流水
  OTC_CONF_ALL: '/foreign/billType', // 资金流水类型
  OTC_BALANCE_BILLTYPE: '/foreign/balance/getBillType', // 账单类型

  // 现货相关接口
  SPOT_COLLECTION_CANCEL: '/attr/a//collection/cancelCollec',
  SPOT_COLLECTION_ADD: '/attr/a/collection/addCollect',
  SPOT_SYMBOL_COIN_LIST: '/attr/a/tradepairs/getCoinList', // 获取交易对币种
  SPOT_SYMBOL_CONFIG_DETAIL: '/pro/v1/public/symbol/detail', // 单个交易对配置信息
  SPOT_SYMBOL_CONFIG_LIST: '/attr/a/tradepairs/getList', // 所有交易对配置信息
  SPOT_TICKER_KLINE: '/attr/a/marketcondition/getKline', // 获取交易对的k线信息
  SPOT_TICKER_DEPTH_LIST: '/attr/a/marketcondition/getDepth', // 获取交易对的深度信息
  SPOT_TICKER_TRADE_LATEST_LIST: '/attr/a/marketcondition/getDeals', // 获取交易对的最新成交信息
  SPOT_BALANCE_BILLS: '/attr/t/fund/bill/getBalanceBills', // 现货流水
  OTC_BALANCE_BILLS: '/attr/t/fund/bill/getOtcBalanceBills', // 资金流水
  SPOT_BALANCE_LIST: '/attr/t/fund/userfund', // 获取用户资产
  SPOT_ORDER_CANCEL: '/attr/t/lm/order/cancelOrder', // 撤销
  SPOT_ORDER_CREATE: '/attr/t/lm/order/createOrder', // 下单
  SPOT_ORDER_DETAIL: '/attr/t/lm/order/getOrderByOrderId', // 根据id查询订单
  SPOT_ORDER_LIST: '/attr/t/lm/order/getOrders', // 订单列表
  SPOT_ORDER_HISTORY: '/attr/t/lm/order/getHistoryOrders', // 历史订单列表
  SPOT_ORDER_BILL_LIST: '/attr/t/lm/order/getTradeList', // 订单成交明细
  SPOT_TICKER_CURRENT_SYMBOL: '/attr/a/marketcondition/getTicker', // 获取指定交易对的行情信息
  SPOT_TICKER_LIST: '/attr/a/marketcondition/getTickers', // 获取全交易对的行情信息
  SPOT_LISTEN_KEY: '/attr/t/listenkey', // 获取listen-key，用于ws订阅
  SPOT_FUND_FLOW: '/attr/t/fund/bill/getBalanceBills', // 现货资金流水
  SPOT_FUND_FLOW_CONF: '/attr/a/conf/fund/spot', // 现货资金流水类型配置

  // 理财
  FINANCE_LOGIN: '/api/financial/user/login', // 登录
  RANK_LIST: '/api/rank/list', //   排行榜
  PROFIT_LIST: '/api/user/profit/list', //   收益
  AEEST_SUMMARY: '/api/u/wallet/assetSummary', //  理财总资金，累计收益

  PRODUCT_LIST: '/api/financial/product/list', // 定期列表
  PRODUCT_PURCHASE: '/api/financial/product/purchase', // 定期购买
  PRODUCT_DETAIL: '/api/financial/product/detail', // 定期宝详情
  PRODUCT_BUY_LIST: '/api/financial/order/buy-list', // 定期宝购买记录
  PRODUCT_ORDER_LIST: '/api/financial/order/order-list', // 定期宝订单列表
  PRODUCT_INCOME_LIST: '/api/financial/income/income-list', // 定期宝产品收益发放明细

  SET_SWITCH: '/api/current/set-switch', //   活期宝自动转入
  CURRENT_LIST: '/api/current/list', // 活期列表
  CURRENT_IN: '/api/current/in', //  活期宝转入
  CURRENT_OUT: '/api/current/out', //  活期宝赎回
  CURRENT_DETAIL: '/api/current/detail', //  活期宝详情
  CURRENT_INCOME: '/api/current/income-list', //  活期宝 产品 收益 发放明细
  CURRENT_IO_LIST: '/api/current/io-list', //  活期宝 存取记录
  CURRENT_ORDER_LIST: '/api/current/order-list', //  活期宝 订单列表
  CURRENT_PLEDGE_DETAIL: '/api/current/pledge-detail', //  活期宝质押详情
  FLOW_LIST: '/api/transaction/list', //  理财流水
  TYPE_LIST: '/api/transaction/type', //  理财流水类型
};
// const socketDomain = `ws://${window.location.host}/ws`;
// 优先使用统一环境配置注入的 REACT_APP_SOCKET_DOMAIN，其次回退到当前域名 ws
const socketDomain = process.env.REACT_APP_SOCKET_DOMAIN;
export const WEBSOCKET_URL_MARKET = `${socketDomain}/market`;

export const WEBSOCKET_URL_USER = `${socketDomain}/user`

export const WEBSOCKET_URL_SPOT = `${socketDomain}/socket`

// 静态资源 S3 前缀，优先使用统一环境配置
export const AMAZON_S3_URL = process.env.REACT_APP_AMAZON_S3_URL